import {
  Box,
  Button,
  Center,
  Container,
  Field,
  Flex,
  Heading,
  Input,
  InputGroup,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import Logo from '@components/Logo';
import { BsArrowLeft } from 'react-icons/bs';
import { useNavigate } from 'react-router';
import { LuMail } from 'react-icons/lu';

import useForm from './useForm';
import ConfirmationDialog from './components/ConfirmationDialog';
import ToggleColorMode from '@components/ToggleColorMode';
import AuthImagePlaceholder from '@components/AuthImagePlaceholder';

const ForgotPassword = () => {
  const navigate = useNavigate();

  const { onSubmit, loading, errors, showConfirmationDialog } = useForm();

  return (
    <Flex height="100vh" flex="1">
      <Box position="absolute" top="4" left="4">
        <ToggleColorMode />
      </Box>
      <Center flex="1.5" py={{ base: '24', md: '32' }}>
        <Container maxW="lg" py={{ base: '12', md: '24' }}>
          <Stack gap="8">
            <VStack gap={8}>
              <Logo width={100} />
              <VStack gap="2" textAlign="center">
                <Heading size="2xl">Esqueceu sua senha?</Heading>
                <Text color="fg.muted">Insira seu e-mail abaixo para receber instruções de recuperação.</Text>
              </VStack>
            </VStack>

            <form onSubmit={onSubmit}>
              <Stack gap={5}>
                <Field.Root invalid={!!errors?.email}>
                  <InputGroup startElement={<LuMail />} width="full" gap={0}>
                    <Input name="email" type="email" placeholder="exemplo@email.com" variant="subtle" required />
                  </InputGroup>
                  {errors?.email?.map((error, index) => (
                    <Field.ErrorText key={index}>{error}</Field.ErrorText>
                  ))}
                </Field.Root>
                <Button colorPalette="argos" size="lg" type="submit" loading={loading}>
                  Continuar
                </Button>
              </Stack>
            </form>

            <VStack textStyle="sm" color="fg.muted" textAlign="center">
              <Button variant="ghost" textDecoration="underline" onClick={() => navigate(-1)}>
                <BsArrowLeft /> Voltar
              </Button>
            </VStack>
          </Stack>

          {showConfirmationDialog && (
            <ConfirmationDialog />
          )}
        </Container>
      </Center>
      <Box flex="1" hideBelow="lg">
        <AuthImagePlaceholder />
      </Box>
    </Flex>
  );
};

export default ForgotPassword;
